import { css } from 'lit';
const styles = css`.cre8-u-content-knockout-brand {
  color: var(----cre8-color-content-knockout-brand);
}

.cre8-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

.cre8-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

@media all and (min-width: 23.4375rem) {
  .cre8-u-hide-sm {
    display: none !important;
  }
}
@media all and (min-width: 35rem) {
  .cre8-u-hide-sm-2 {
    display: none !important;
  }
}
@media all and (min-width: 48rem) {
  .cre8-u-hide-md {
    display: none !important;
  }
}
@media all and (min-width: 60rem) {
  .cre8-u-hide-lg {
    display: none !important;
  }
}
@media all and (min-width: 75rem) {
  .cre8-u-hide-xl {
    display: none !important;
  }
}
@media all and (max-width: 23.4375rem) {
  .cre8-u-show-sm {
    display: none !important;
  }
}
@media all and (max-width: 35rem) {
  .cre8-u-show-sm-2 {
    display: none !important;
  }
}
@media all and (max-width: 48rem) {
  .cre8-u-show-md {
    display: none !important;
  }
}
@media all and (max-width: 60rem) {
  .cre8-u-show-lg {
    display: none !important;
  }
}
@media all and (max-width: 75rem) {
  .cre8-u-show-xl {
    display: none !important;
  }
}
.cre8-u-margin-none {
  margin: 0 !important;
}

.cre8-u-margin-sm {
  margin: size(1) !important;
}

.cre8-u-margin-md {
  margin: size(2) !important;
}

.cre8-u-margin-lg {
  margin: size(3) !important;
}

.cre8-u-margin-xl {
  margin: size(4) !important;
}

.cre8-u-margin-xxl {
  margin: size(8) !important;
}

.cre8-u-margin-top-none {
  margin-top: 0 !important;
}

.cre8-u-margin-top-sm {
  margin-top: size(1) !important;
}

.cre8-u-margin-top-md {
  margin-top: size(2) !important;
}

.cre8-u-margin-top-lg {
  margin-top: size(3) !important;
}

.cre8-u-margin-top-xl {
  margin-top: size(4) !important;
}

.cre8-u-margin-top-xxl {
  margin-top: size(8) !important;
}

.cre8-u-margin-right-none {
  margin-right: 0 !important;
}

.cre8-u-margin-right-sm {
  margin-right: size(1) !important;
}

.cre8-u-margin-right-md {
  margin-right: size(2) !important;
}

.cre8-u-margin-right-lg {
  margin-right: size(3) !important;
}

.cre8-u-margin-right-xl {
  margin-right: size(4) !important;
}

.cre8-u-margin-right-xxl {
  margin-right: size(8) !important;
}

.cre8-u-margin-bottom-none {
  margin-bottom: 0 !important;
}

.cre8-u-margin-bottom-sm {
  margin-bottom: size(1) !important;
}

.cre8-u-margin-bottom-md {
  margin-bottom: size(2) !important;
}

.cre8-u-margin-bottom-lg {
  margin-bottom: size(3) !important;
}

.cre8-u-margin-bottom-xl {
  margin-bottom: size(4) !important;
}

.cre8-u-margin-bottom-xxl {
  margin-bottom: size(8) !important;
}

.cre8-u-margin-bottom-xl-xxl {
  margin-bottom: size(4) !important;
}

@media all and (min-width: 768px) {
  .cre8-u-margin-bottom-xl-xxl {
    margin-bottom: size(8) !important;
  }
}
.cre8-u-margin-left-none {
  margin-left: 0 !important;
}

.cre8-u-margin-left-sm {
  margin-left: size(1) !important;
}

.cre8-u-margin-left-md {
  margin-left: size(2) !important;
}

.cre8-u-margin-left-lg {
  margin-left: size(3) !important;
}

.cre8-u-margin-left-xl {
  margin-left: size(4) !important;
}

.cre8-u-margin-left-xxl {
  margin-left: size(8) !important;
}

.cre8-u-padding-none {
  padding: 0 !important;
}

.cre8-u-padding-sm {
  padding: size(1) !important;
}

.cre8-u-padding-md {
  padding: size(2) !important;
}

.cre8-u-padding-lg {
  padding: size(3) !important;
}

.cre8-u-padding-xl {
  padding: size(4) !important;
}

.cre8-u-padding-xxl {
  padding: size(8) !important;
}

.cre8-u-padding-top-none {
  padding-top: 0 !important;
}

.cre8-u-padding-top-sm {
  padding-top: size(1) !important;
}

.cre8-u-padding-top-md {
  padding-top: size(2) !important;
}

.cre8-u-padding-top-lg {
  padding-top: size(3) !important;
}

.cre8-u-padding-top-xl {
  padding-top: size(4) !important;
}

.cre8-u-padding-top-xxl {
  padding-top: size(8) !important;
}

.cre8-u-padding-right-none {
  padding-right: 0 !important;
}

.cre8-u-padding-right-sm {
  padding-right: size(1) !important;
}

.cre8-u-padding-right-md {
  padding-right: size(2) !important;
}

.cre8-u-padding-right-lg {
  padding-right: size(3) !important;
}

.cre8-u-padding-right-xl {
  padding-right: size(4) !important;
}

.cre8-u-padding-right-xxl {
  padding-right: size(8) !important;
}

.cre8-u-padding-bottom-none {
  padding-bottom: 0 !important;
}

.cre8-u-padding-bottom-sm {
  padding-bottom: size(1) !important;
}

.cre8-u-padding-bottom-md {
  padding-bottom: size(2) !important;
}

.cre8-u-padding-bottom-lg {
  padding-bottom: size(3) !important;
}

.cre8-u-padding-bottom-xl {
  padding-bottom: size(4) !important;
}

.cre8-u-padding-bottom-xxl {
  padding-bottom: size(8) !important;
}

.cre8-u-padding-left-none {
  padding-left: 0 !important;
}

.cre8-u-padding-left-sm {
  padding-left: size(1) !important;
}

.cre8-u-padding-left-md {
  padding-left: size(2) !important;
}

.cre8-u-padding-left-lg {
  padding-left: size(3) !important;
}

.cre8-u-padding-left-xl {
  padding-left: size(4) !important;
}

.cre8-u-padding-left-xxl {
  padding-left: size(8) !important;
}

.cre8-u-display-flex {
  display: flex !important;
}

.cre8-u-display-block {
  display: block !important;
}

body {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  -webkit-text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  color: var(--cre8-color-content-default);
  background: var(--background-default);
}

@media all and (min-width: 60rem) {
  .page-container {
    background: linear-gradient(90deg, #fff 0, #fff 66.66%, #f8f8f9 0, #f8f8f9 0);
  }
}
.band__inner {
  margin-left: 2rem;
  margin-right: 2rem;
}

@media all and (min-width: 60rem) {
  .band__inner {
    margin-right: 0;
  }
}
img {
  max-width: 100%;
  height: auto;
}

/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/*
=======
Animations
=======
*/
:host {
  --cre8-z-index-1: 1;
  --cre8-z-index-50: 50;
  --cre8-z-index-100: 100;
  --cre8-z-index-200: 200;
  --cre8-z-index-1030: 1030;
  --cre8-anim-fade-quick: 0.35s;
  --cre8-anim-ease: ease;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes slideIn {
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFwd {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideOutRight {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideUp {
  100% {
    transform: translateY(0);
  }
}
@media (width >= 481px) {
  @keyframes slideInFwd {
    100% {
      width: 417px;
      height: 417px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 417px;
      height: 417px;
    }
  }
}
@media (width >= 48rem) {
  @keyframes slideInFwd {
    100% {
      width: 330px;
      height: 330px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 330px;
      height: 330px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 60rem) {
  @keyframes slideInFwd {
    100% {
      width: 460px;
      height: 460px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 460px;
      height: 460px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 75rem) {
  @keyframes slideInFwd {
    100% {
      width: 592px;
      height: 591px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 87.5rem) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 120px));
    }
  }
}
@media (width >= 2200px) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 592px));
    }
  }
}
span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: var(--ripple-bg-color);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 1;
  }
}
:root {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
* Accordion Item panel button
* 1) Icon rotating on open was causing scrollbar to continuously appear/disappear
*    during the animation, overflow-x: hidden; prevents this from happening
*/
:host {
  display: block;
}
:host ::slotted(*) {
  text-align: left;
  width: 100%;
}

.cre8-c-accordion-item {
  border-bottom: var(--cre8-accordion-item-border-bottom);
  border-radius: var(--cre8-border-radius-none);
  --cre8-u-icon-display: flex;
  --cre8-u-icon-align-items: center;
  --cre8-u-icon-justify-content: center;
  padding: 1.5rem 0.5rem;
}

.cre8-c-accordion-item--small cre8-heading button {
  font-family: var(--cre8-typography-title-default-mobile-font-family);
  font-size: var(--cre8-typography-title-default-mobile-font-size);
  font-weight: var(--cre8-typography-title-default-mobile-font-weight);
  line-height: var(--cre8-typography-title-default-mobile-line-height);
  text-decoration: var(--cre8-typography-title-default-mobile-text-decoration);
  text-transform: var(--cre8-typography-title-default-mobile-text-transform);
}
@media all and (min-width: 768px) {
  .cre8-c-accordion-item--small cre8-heading button {
    font-family: var(--cre8-typography-title-default-font-family);
    font-size: var(--cre8-typography-title-default-font-size);
    font-weight: var(--cre8-typography-title-default-font-weight);
    line-height: var(--cre8-typography-title-default-line-height);
    text-decoration: var(--cre8-typography-title-default-text-decoration);
    text-transform: var(--cre8-typography-title-default-text-transform);
  }
}

.cre8-c-accordion-item--large cre8-heading button {
  font-family: var(--cre8-typography-title-large-mobile-font-family);
  font-size: var(--cre8-typography-title-large-mobile-font-size);
  font-weight: var(--cre8-typography-title-large-mobile-font-weight);
  line-height: var(--cre8-typography-title-large-mobile-line-height);
  text-decoration: var(--cre8-typography-title-large-mobile-text-decoration);
  text-transform: var(--cre8-typography-title-large-mobile-text-transform);
}
@media all and (min-width: 768px) {
  .cre8-c-accordion-item--large cre8-heading button {
    font-family: var(--cre8-typography-title-large-font-family);
    font-size: var(--cre8-typography-title-large-font-size);
    font-weight: var(--cre8-typography-title-large-font-weight);
    line-height: var(--cre8-typography-title-large-line-height);
    text-decoration: var(--cre8-typography-title-large-text-decoration);
    text-transform: var(--cre8-typography-title-large-text-transform);
  }
}

.cre8-c-accordion-item__body {
  margin-right: 0rem;
  margin-left: 0rem;
  padding: 0rem;
  overflow: hidden;
  visibility: hidden;
  transition: height var(--cre8-anim-fade-quick) var(--cre8-anim-ease), visibility var(--cre8-anim-fade-quick) var(--cre8-anim-ease);
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__body {
  visibility: visible;
}

.cre8-c-accordion-item__body-inner {
  display: flex;
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  padding: 0.5rem 3rem 0rem 0.5rem;
}

cre8-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  min-height: 1.5rem;
  min-width: 1.5rem;
  transition: transform var(--cre8-anim-fade-quick) var(--cre8-anim-ease);
  width: 1.5rem;
}
.cre8-c-accordion-item.cre8-is-active cre8-icon {
  transform: rotate(180deg);
}

.cre8-c-accordion-item__icon {
  align-items: center;
  background: var(--cre8-color-bg-brand-strong);
  border-radius: var(--cre8-border-radius-round);
  color: var(--cre8-color-content-knockout);
  display: flex;
  height: 2rem;
  justify-content: center;
  margin-left: 0.5rem;
  margin-right: 0.125rem;
  min-height: 2rem;
  min-width: 2rem;
  width: 2rem;
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__icon {
  background: var(--cre8-color-button-secondary-bg);
  border: var(--cre8-border-width-default) var(--cre8-border-style-default) var(--cre8-color-button-secondary-border);
  color: var(--cre8-color-button-secondary-content);
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__icon:hover {
  border-color: var(--cre8-color-button-secondary-border-hover);
  background-color: var(--cre8-color-button-secondary-bg-hover);
  color: var(--cre8-color-button-secondary-content-hover);
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__icon:focus {
  border-radius: var(--cre8-border-radius-default);
  box-shadow: 0rem 0rem 0rem 0.125rem var(--cre8-color-border-active-outline);
  outline: none;
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__icon:focus .cre8-c-accordion-item__icon {
  border-color: var(--cre8-color-button-secondary-border-active);
  color: var(--cre8-color-button-secondary-content-active);
  background-color: var(--cre8-color-button-secondary-bg-active);
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__icon:focus .cre8-c-accordion-item__tertiary-icon {
  border-color: var(--cre8-color-border-transparent);
  color: var(--cre8-color-button-tertiary-content-active);
  background-color: var(--cre8-color-bg-transparent);
}

.cre8-c-accordion-item__button {
  color: var(--cre8-color-content-default);
  display: block;
  appearance: none;
  background-color: var(--cre8-color-bg-transparent);
  border: var(--cre8-border-width-none);
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  overflow-x: hidden;
  transition: color var(--cre8-anim-fade-quick) var(--cre8-anim-ease);
  width: 100%;
}
.cre8-c-accordion-item__button.cre8-brand-color {
  color: var(--cre8-color-content-brand-strong);
}
.cre8-c-accordion-item__button.cre8-u-justify-content-start {
  justify-content: flex-start;
}
.cre8-c-accordion-item__button.cre8-u-justify-content-start .cre8-c-accordion-item__icon-before {
  margin-left: 0rem;
}
.cre8-c-accordion-item__button:hover .cre8-c-accordion-item__icon {
  border-color: var(--cre8-color-button-primary-border-hover);
  background-color: var(--cre8-color-button-primary-bg-hover);
  color: var(--cre8-color-button-primary-content-hover);
}
.cre8-c-accordion-item.cre8-is-active .cre8-c-accordion-item__button:hover .cre8-c-accordion-item__icon {
  border-color: var(--cre8-color-button-secondary-border-hover);
  background-color: var(--cre8-color-button-secondary-bg-hover);
  color: var(--cre8-color-button-secondary-content-hover);
}
.cre8-c-accordion-item__button:hover .cre8-c-accordion-item__tertiary-icon {
  border-color: var(--cre8-color-border-transparent);
  color: var(--cre8-color-button-tertiary-content-hover);
  background-color: var(--cre8-color-bg-transparent);
}
.cre8-c-accordion-item__button:focus {
  border-radius: var(--cre8-border-radius-default);
  box-shadow: 0rem 0rem 0rem 0.125rem var(--cre8-color-border-active-outline);
  outline: none;
}
.cre8-c-accordion-item__button:focus .cre8-c-accordion-item__icon {
  border-color: var(--cre8-color-button-primary-border-active);
  color: var(--cre8-color-button-primary-content-active);
  background-color: var(--cre8-color-button-primary-bg-active);
}
.cre8-c-accordion-item__button:focus .cre8-c-accordion-item__tertiary-icon {
  border-color: var(--cre8-color-border-transparent);
  color: var(--cre8-color-button-tertiary-content-active);
  background-color: var(--cre8-color-bg-transparent);
}

.cre8-c-accordion-item--icon-before .cre8-c-accordion-item__body {
  margin-left: 2.5rem;
}

.cre8-c-accordion-item__icon-before {
  margin-right: 0.75rem;
}
.cre8-c-accordion-item__icon-before h4[slot=header] {
  display: block;
  pointer-events: none;
}

.cre8-c-accordion-item__button slot {
  display: contents;
  text-align: initial;
}

.cre8-c-accordion-item--icon-before-heading-text {
  display: flex;
  text-align: left;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-width: 100%;
}

.cre8-c-accordion-item--icon-after-heading-text {
  display: flex;
  text-align: left;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 100%;
}`;
export default styles;
